/*
 * Count-up for the stat bands. Shared by sections/cvc-stats.liquid and the band
 * inside sections/cvc-home.liquid, so the behaviour cannot drift between them.
 *
 * The final numbers are already in the markup. This only ever animates up to a
 * figure that is correct without it, so a reader with reduced motion, a failed
 * script or a dead IntersectionObserver still sees the right number.
 */
(function () {
  function animate(grid) {
    var nums = [].slice.call(grid.querySelectorAll('.cvc-stat-n[data-to]'));
    if (!nums.length) return;
    nums.forEach(function (el) {
      var raw = String(el.getAttribute('data-to'));
      var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (!isFinite(target)) return;                 // "Signed", "Numbered" and the like

      /*
        Anything wrapped around the digits is kept.

        This used to read the number, throw away everything that was not a
        digit, and rewrite the element on the final frame - so a merchant who
        typed "700+" watched it animate and land on "700". The plus had to be
        smuggled into the LABEL instead, which is why the band read "Over 700
        Tested recipes" with the number repeated in two fields that could then
        disagree with each other. It was also inconsistent: with reduced motion
        on, the script returns early and the "+" survived, so the same site
        showed two different numbers depending on a system preference.

        A section that declares data-prefix or data-suffix still wins - the
        standalone Stat band sets them from its own settings - and otherwise
        they are taken from whatever sits either side of the digits, so "700+",
        "$40" and "2017" all come out as typed.
      */
      var around = /^([^0-9.]*)[0-9.]+([^0-9.]*)$/.exec(raw) || ['', '', ''];
      var pre = el.getAttribute('data-prefix') || around[1] || '';
      var suf = el.getAttribute('data-suffix') || around[2] || '';
      var dur = 1100, t0 = null;
      // A year counting up from zero looks like a fault.
      var from = target > 1900 ? target - 40 : 0;
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var v = Math.round(from + (target - from) * (1 - Math.pow(1 - p, 3)));
        el.textContent = pre + v + suf;
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = pre + target + suf;
      }
      requestAnimationFrame(tick);
    });
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    [].slice.call(document.querySelectorAll('[data-cvc-stats]')).forEach(function (grid) {
      if (grid.dataset.cvcStatsDone) return;
      var done = false;
      function go() { if (!done) { done = true; grid.dataset.cvcStatsDone = '1'; animate(grid); } }
      if (!('IntersectionObserver' in window)) { go(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); go(); } });
      }, { rootMargin: '0px 0px -15% 0px' });
      io.observe(grid);
      setTimeout(go, 4000);   // backstop; the numbers are already correct either way
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
